import preset from "@dreamhub/designsystem/tailwind-preset";

// The app also imports this file into the browser bundle (src/utils/tailwind.tsx resolves it for
// breakpoints), so it must not import Node modules, and reads the environment through globalThis,
// where the browser has no process. With VITE_LINK_DESIGNSYSTEM pointing at a designsystem
// checkout, vite.config.ts serves the package from its src, so its classes are scanned there.
const linkedDesignSystem = globalThis.process?.env?.VITE_LINK_DESIGNSYSTEM;
const designSystemContent = linkedDesignSystem
  ? `${linkedDesignSystem.replace(/\/+$/, "")}/src/**/*.{ts,tsx}`
  : "./node_modules/@dreamhub/designsystem/dist/**/*.js";

/** @type {import('tailwindcss').Config} */
export default {
  presets: [preset],
  content: [
    "./pages/**/*.{ts,tsx}",
    "./components/**/*.{ts,tsx}",
    "./app/**/*.{ts,tsx}",
    "./src/**/*.{ts,tsx}",
    designSystemContent,
  ],
  prefix: "",
  // index.css styles svg.lucide, but no webapp source names the class, so Tailwind has never
  // emitted that rule. The package's GripVertical.svg does name it; blocking the candidate keeps
  // the built CSS identical to before the package was installed.
  blocklist: ["lucide"],
};
